import {Directive, inject, model, ModelSignal, Signal, viewChild, WritableSignal,} from '@angular/core';
import {ProcessOverviewStore} from "../process-overview/service/process-overview.store";
import {NotBillableService} from "../../../api/generated";
import {AG_GRID_GERMAN_LOCALE, DialogService} from "frontier";
import {ICart} from "../process-overview/service/state.interface";
import {
  NotBillableFormComponent
} from "../process-overview/cart-details/conspicuity-detail/not-billable-form/not-billable-form.component";
import {IDisplayOnlyFlag} from "../process-overview/cart-details/conspicuity-detail/display-flag.interface";
import {
  IClientMessageDetails
} from "../process-overview/cart-details/conspicuity-detail/client-message-details/client-message-details.interface";
import {IClientsTileApi} from "../process-overview/cart-details/conspicuity-detail/clients-tile.interface";
import {ColDef, GetRowIdParams, GridOptions, GridReadyEvent} from "ag-grid-community";
import {Observable, of} from "rxjs";
import {concatMap} from "rxjs/operators";
import {DynamicTooltipService} from "../../../Services/dynamic-tooltip.service";

@Directive({
  selector: 'app-client-comparator-not-billable-form-template',
  standalone: true,
})
export class ClientComparatorNotBillableFormTemplateComponent {
  protected _processOverviewService: ProcessOverviewStore = inject(ProcessOverviewStore);
  protected _notBillableService: NotBillableService = inject(NotBillableService);
  protected _dialogService: DialogService = inject(DialogService);
  dynamicTooltipService: DynamicTooltipService = inject(DynamicTooltipService);

  numberOfWantedClients: ModelSignal<number> = model<number>(3);
  minScore: ModelSignal<number> = model<number>(0.4);
  availableClients: ModelSignal<number> = model<number>();
  selectedCart: Signal<ICart> = this._processOverviewService.selectedCart;
  notBillableFormRef: Signal<NotBillableFormComponent> = viewChild(NotBillableFormComponent);
  displayOnlyFlags: ModelSignal<IDisplayOnlyFlag[]> = model<IDisplayOnlyFlag[]>([]);
  isCollectibleApprovable: ModelSignal<boolean> = model<boolean>(false);
  clientsMessage: WritableSignal<IClientMessageDetails> = model(undefined);
  rowData: ModelSignal<IDisplayOnlyFlag[]> = model(null);
  clients: ModelSignal<IClientsTileApi[]> = model<IClientsTileApi[]>();

  colDefs: ColDef[] = [
    {field: 'label', width: 205, maxWidth: 205, minWidth: 205, cellStyle: {'font-weight': 'bold'}},
    {field: 'value', tooltipField: 'tooltip', wrapText: true, autoHeight: true, resizable: true},
  ];

  gridOptions: GridOptions = {
    localeText: AG_GRID_GERMAN_LOCALE,
    rowHeight: 30,
    headerHeight: 0,
    onGridReady: (event: GridReadyEvent) => event.api.sizeColumnsToFit(),
    getRowId: (params: GetRowIdParams) => params.data.label,
  };

  onGetAnotherClient(event: number): void {
    this.getAnotherClient(event).subscribe();
  }

  getAnotherClient(evt: number): Observable<void> {
    // +1 (we want one more) and -1 (current client is also counted) cancel out
    this.numberOfWantedClients.set(evt);
    if (this.numberOfWantedClients() > this.availableClients()) {
      this.minScore.update((val: number): number => val -= 0.05);
    }
    return this._notBillableService.notBillableGetSimilarClients(
      {
        InstanceId: this.notBillableFormRef().instanceId(),
        count: this.numberOfWantedClients(),
        minimumScore: this.minScore(),
      }
    ).pipe(
      concatMap((similarClients: IClientsTileApi[]): Observable<void> => {
        if (similarClients.length > this.numberOfWantedClients()) {
          this.availableClients.set(similarClients[0].HitRate);
          this.clients.set([...similarClients]);
        } else {
          this.minScore.update((val: number) => val - 0.05);
          return this.getAnotherClient(evt);
        }
        return of(null);
      }),
    )
  }
}
